import React, { useState, useEffect } from "react";
import StateServices from "services/StateServices";
import Select from "react-select";
const SelectStateSingle = ({
  register,
  selectedState,
  selectedCountryId,
  handleStateChange,
  name,
  label,
  readOnly,
}) => {
  const [states, setState] = useState([]);
  const customSelectStyles = {
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: "0", // Optional: Adjust padding
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
    control: (base, state) => ({
      ...base,
      border: "1px",
      boxShadow: "none",
      backgroundColor: "RRGGBB",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "#0e9f6e"
        : state.isFocused
        ? "rgba(0, 0, 0, 0.15)"
        : "white",
      color: state.isSelected ? "white" : state.onClick ? "green" : "black",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.15)", // Change the background color on hover
        color: "black", // Change the text color on hover
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      margin: "10px 0 -10px 0", // Add margin to the entire option box
    }),
  };

  useEffect(() => {
    if (selectedCountryId) {
      async function fetchState() {
        try {
          const response = await StateServices.getStateByCountryID(
            selectedCountryId
          );
          const transformedData = response.map((item) => ({
            value: item.id_state,
            label: item.name,
            call_prefix: item.call_prefix,
          }));
          setState(transformedData);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      }

      fetchState();
    }
  }, [selectedCountryId]);
  const handleStateSelect = async (selected) => {
    const item = states.find((item) => String(item.value) === String(selected.value));

    if (item) {
      handleStateChange(selected.value);
    }
  };
  return (
    <Select
      className="text-sm focus:outline-none dark:text-white-300 leading-5 rounded-md focus:border-white-200 border-gray-200 dark:border-gray-600 focus:ring focus:ring-green-300 dark:focus:border-gray-500 dark:focus:ring-gray-300 dark:bg-gray-700 border h-10 text-sm focus:outline-none bg-white-100 dark:bg-white border-transparent focus:bg-white"
      // isSearchable={false}
      {...register(`${name}`, {
        required: !selectedState ? `${label} is required!` : false,
      })}
      defaultValue={states[0]}
      name={name}
      styles={customSelectStyles}
      isDisabled={readOnly}
      options={states}
      onChange={handleStateSelect}
      value={
        selectedState
          ? states.find(
              (option) =>
                String(option.value) === String(selectedState) ||
                String(option.label) === String(selectedState)
            )
          : null
      }
      
    />
  );
};

export default SelectStateSingle;
